export const BASE_URL = process.env.REACT_APP_BASE_URL
export const FEEDBACK_BASE_URL = process.env.REACT_APP_FEEDBACK_BASE_URL
export const CONNECTION_BASE_URL = process.env.REACT_APP_CONNECTION_BASE_URL
export const AUTHORITY_URL = process.env.REACT_APP_AUTHORITY_URL
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID
